import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 20000,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("access_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    async (err) => {
        if (err.response?.status === 401) {
            // attempt refresh
            const refresh = localStorage.getItem("refresh_token");
            if (refresh && !err.config._retry) {
                try {
                    err.config._retry = true;
                    const { data } = await axios.post(`${API}/auth/refresh`, {
                        refresh_token: refresh,
                    });
                    localStorage.setItem("access_token", data.access_token);
                    localStorage.setItem("refresh_token", data.refresh_token);
                    err.config.headers.Authorization = `Bearer ${data.access_token}`;
                    return axios(err.config);
                } catch (_) {
                    localStorage.removeItem("access_token");
                    localStorage.removeItem("refresh_token");
                }
            }
        }
        return Promise.reject(err);
    },
);
